import { FPhi } from "@facephi/selphi-widget-web";
import React, { useEffect } from "react";
import { FaceCapture, TrackingSteps, useSdk, useTracking, AssetsType  } from "@facephi/sdk-web";
import { setBestSelphiImage, setBestImageTokenized } from "../../../features/registration/registrationSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectGlobalDataState } from "../../../features/global/globalDataSlice";
import { sendGeneralRequest } from "../../../features/generalRequest";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { texts } from "../../general/texts";
import colors from "../../colors";
import { setOperationId } from "../../../features/utilities/utilitySlice";
import { selectRegistrationState } from '../../../features/registration/registrationSlice';
import { selectUtilityState } from '../../../features/utilities/utilitySlice';

const Selphi = ({ onBestImageCropped }) => {

  const dispatch = useDispatch();
  const globalDataSliceState = useSelector(selectGlobalDataState);
  const registrationSliceState = useSelector(selectRegistrationState);
  const utilitySliceState = useSelector(selectUtilityState);
  const selphiPath = process.env.PUBLIC_URL + "/widgets/selphi";

  const removePrefix = (base64String) => {
    if (base64String.startsWith('data:image/jpeg;base64,')) {
      return base64String.slice('data:image/jpeg;base64,'.length);
    }
    return base64String;
  };

  const {
    trackingAsset,
    trackingEvent,
    trackingStart,
    operationId,
    sessionId
  } = useTracking();
  const {extraData}= useSdk()

  useEffect(() => {
    trackingStart(
    [
    TrackingSteps.start,
    TrackingSteps.selphiWidget,
    TrackingSteps.selphidWidget,
    TrackingSteps.finish,
    ],
    globalDataSliceState.username
  )
  }, [])

  useEffect(() => {
  if( extraData && operationId){
    setOperationId(operationId)
    console.log(extraData)
    console.log(operationId)
    trackingEvent(TrackingSteps.selphiWidget, TrackingSteps.selphiWidget)
  }
  }, [extraData, operationId])

  const onExtractionFinished = (extractionResult) => {
    const bestImageTokenized = extractionResult.detail.bestImageTokenized;

    trackingAsset(extractionResult.detail.bestImage.src, AssetsType.selfie)
    dispatch(setBestImageTokenized(bestImageTokenized));
    FPhi.Selphi.Component.generateTemplateRawFromByteArray(
      window.location.origin + "/widgets/selphi",
      extractionResult.detail.bestImage,
      (result) => {
        onBestImageCropped(bestImageTokenized);
        dispatch(setBestSelphiImage(result));
        dispatch(
          sendGeneralRequest({
            request: {
              token: utilitySliceState.isUanatacaDialogOpen || registrationSliceState.isUpgrading ? globalDataSliceState.token : registrationSliceState.token,
              tenantId: "e9b039fa-0a2f-4149-9acc-a7e20a46464e",
              customerId: globalDataSliceState.username,
              operationId: operationId,
              sessionId: sessionId,
              bestImage: result,
              imageb64: removePrefix(extractionResult.detail.bestImage.src),
            },
            baseUrlKey: "auth",
            endpoint: "Onboarding/PostPassiveLiveness",
          })
        )
          .then(response => {
            if (response.error) {
              showSwal()
            }
          })
      }
    );
  }

  const showSwal = () => {
    withReactContent(Swal).fire({
      title: texts['title-warning'],
      icon: "warning",
      allowOutsideClick: false,
      confirmButtonColor: colors.orange,
      confirmButtonText: texts['try-again']
    }).then(() => {
      onBestImageCropped(null)
    })
  };

  return (
    <FaceCapture
      bundlePath={selphiPath}
      onExtractionFinish={(extractionResult) => onExtractionFinished(extractionResult)}
      externalcamera={true}
      tutorial={true}
      showLoading={true}
      cropFactor={2}
      help={true}
      fullScreen={true}
      tries={2}
      language="al"
    />
  );
};

export default Selphi;
